/**
 * 用户 签署安全管理
 * 2018.8.4
 */


import ApiPort from "../config/api-port";
import HttpAxios from "./http-axios";
import GlobalConfig from '../config/global'
import {handleError, handleResponse} from "../lib/common";

const junziqianApi = GlobalConfig.domain.junziqianApi

export default {

  /**
   * 签署密码开关设置
   * @param signPwd  签署密码
   * @param randomCode  图形验证码
   * @param flag  开关0关闭，1打开
   * @returns {Promise<T>}
   */
  signPwdSwitch ({signPwd, randomCode, flag}) {
    let url = junziqianApi + ApiPort.securityController.signPwdSwitch
    let jsonData = {signPwd: signPwd, randomCode: randomCode, flag: flag}

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError)
  },

  /**
   * 签署密码保存
   * @param signPwd 新签署密码
   * @param sign 签名
   * @param ts 时间戳
   * @returns {Promise<T>}
   */
  signPwdSave({signPwd, sign, ts}) {
    let url = junziqianApi + ApiPort.securityController.signPwdSave
    let jsonData = {signPwd: signPwd, sign: sign, ts: ts}

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError)
  },

  /**
   * 获取签署密码信息
   * @returns {Promise<T>}
   */
  signPwdInfo () {
    let url = junziqianApi + ApiPort.securityController.signPwdInfo

    return HttpAxios.post(url, {})
      .then(handleResponse)
      .catch(handleError)
  }
}



// WEBPACK FOOTER //
// ./assets/js/http-serve/securityController.js